import React, { useEffect, useState } from "react";
import { httpReauest } from "../../../utils/httpRequest";
import { Link, useSearchParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import Loading from "../Loading";
import { CDN_BASE_URL } from "../../../config";

const RequestFindMobile = () => {
  const [loading, setLoading] = useState();
  const [brands, setbrands] = useState();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  async function getData(params) {
    await httpReauest("GET", "/brand", {}, {}).then(({ data }) => {
      setbrands(data?.data);
    });
  }

  const VALUE_SIGN_VALIDATION = () => {
    return Yup.object({
      price: Yup.string().required("الزامی است"),
      lazing: Yup.string().required("الزامی است"),
    });
  };

  const formik = useFormik({
    initialValues: { brand: "", price: "", lazing: "" },
    validationSchema: VALUE_SIGN_VALIDATION,
    onSubmit: async (values) => {
      setLoading(true);
      await httpReauest(
        "GET",
        `/vehicle?min_price=${
          (Number(values.price.replaceAll(",", "")) - 300000000) / 1000000000
        }&max_price=${
          (Number(values.price.replaceAll(",", "")) + 300000000) / 1000000000
        }&lazing=${values.lazing}&brand=${values.brand}`,
        {},
        {}
      ).then(({ data }) => {
        setProducts(data.data);
        setLoading(false);
      });
    },
  });

  function handleChangePrice(params) {
    const value = params.target.value;
    const formattedValue = (
      Number(value.replace(/\D/g, "")) || ""
    ).toLocaleString();
    formik.setFieldValue("price", formattedValue);
  }

  return (
    <>
      <form
        onSubmit={formik.handleSubmit}
        className="py-7 border-t border-b border-dashed border-[#8E9192] flex flex-col gap-4"
      >
        <span className="relative">
          <input
            className={` w-full form-brand-mobile`}
            placeholder="بودجه شما"
            id="price"
            value={formik.values.price}
            name="price"
            onChange={handleChangePrice}
            onBlur={formik.handleBlur}
          />
          <p className="absolute translate-y-[-50%] top-[24px] text-[14px]  left-4">
            تومان
          </p>

          {formik.errors.price && formik.touched.price && (
            <p style={{ color: "red", fontSize: "12px" }}>
              {formik.errors.price}
            </p>
          )}
        </span>
        <span className="relative">
          <select
            className={` w-full form-brand-mobile`}
            id="lazing"
            value={formik.values.lazing}
            name="lazing"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <option value={""}>شرایط اقساطی</option>
            <option>لیزینگ دولتی</option>
            <option>لیزینگ خصوصی</option>
            <option>لیزینگ نمایشگاه</option>
          </select>
          {formik.errors.lazing && formik.touched.lazing && (
            <p style={{ color: "red", fontSize: "12px" }}>
              {formik.errors.lazing}
            </p>
          )}
        </span>
        <span className="relative">
          <select
            className={` w-full form-brand-mobile `}
            placeholder="خودرو"
            id="brand"
            value={formik.values.brand}
            name="brand"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <option>همه برند ها</option>
            {brands?.map((e) => (
              <option value={e._id}>{e.title}</option>
            ))}
          </select>
          {formik.errors.brand && formik.touched.brand && (
            <p style={{ color: "red", fontSize: "12px" }}>
              {formik.errors.brand}
            </p>
          )}
        </span>
        <button type="submit" className="btn-brand w-full">
          پیداش کن
        </button>
      </form>
      <div className="grid grid-cols-3 gap-1 pt-4 pb-7">
        {loading ? (
          <div className="flex justify-center col-span-full">
            <Loading />
          </div>
        ) : (
          products?.map((e) => (
            <Link
              to={`/${e?.url?.category?.url}/${e?.url?.brand?.name}/${e?.url?.name}`}
            >
              <img
                alt={e.name}
                title={e.name}
                className="object-cover rounded-[6px] h-[29vw] w-full"
                src={CDN_BASE_URL + e.img}
              />
            </Link>
          ))
        )}
      </div>
    </>
  );
};

export default RequestFindMobile;
